// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding-support-chat__launcher {
  position: fixed;
  right: 24px;
  bottom: calc(96px + env(safe-area-inset-bottom, 0px));
  z-index: 180;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 14px;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  box-shadow: 0 8px 26px rgba(0, 0, 0, 0.14), 0 2px 8px rgba(0, 0, 0, 0.08);
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.15s ease, border-color 0.15s ease, background 0.15s ease;
}

.onboarding-support-chat__launcher:hover {
  transform: translateY(-1px);
  border-color: var(--color-accent-base);
  background: var(--color-bg-input);
}

.onboarding-support-chat__launcher svg {
  flex: 0 0 auto;
}

@media (max-width: 520px) {
  .onboarding-support-chat__launcher {
    right: 16px;
    bottom: calc(88px + env(safe-area-inset-bottom, 0px));
    width: 40px;
    justify-content: center;
    padding: 0;
  }

  .onboarding-support-chat__launcher span {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/OnboardingSupportChat.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,qDAAqD;EACrD,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,gCAAgC;EAChC,yEAAyE;EACzE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,qDAAqD;IACrD,WAAW;IACX,uBAAuB;IACvB,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".onboarding-support-chat__launcher {\n  position: fixed;\n  right: 24px;\n  bottom: calc(96px + env(safe-area-inset-bottom, 0px));\n  z-index: 180;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 40px;\n  padding: 0 14px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  box-shadow: 0 8px 26px rgba(0, 0, 0, 0.14), 0 2px 8px rgba(0, 0, 0, 0.08);\n  font: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.15s ease, border-color 0.15s ease, background 0.15s ease;\n}\n\n.onboarding-support-chat__launcher:hover {\n  transform: translateY(-1px);\n  border-color: var(--color-accent-base);\n  background: var(--color-bg-input);\n}\n\n.onboarding-support-chat__launcher svg {\n  flex: 0 0 auto;\n}\n\n@media (max-width: 520px) {\n  .onboarding-support-chat__launcher {\n    right: 16px;\n    bottom: calc(88px + env(safe-area-inset-bottom, 0px));\n    width: 40px;\n    justify-content: center;\n    padding: 0;\n  }\n\n  .onboarding-support-chat__launcher span {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
